module.exports = __webpack_public_path__ + "static/media/013.eabab8a7.jpg";